export * from './lib/shared-feature-configure-data.module';
export * from './lib/configure-data.component';
